export const hiText = () => {
  let date = new Date();
  let hour = date.getHours(); //返回0-23
  if (hour > 4 && hour < 10) {
    this.hiText = '上午好'
  } else if (hour >= 10 && hour <= 12) {
    this.hiText = '中午好'
  } else if (hour > 12 && hour < 17) {
    this.hiText = '下午好'
  } else if (hour >= 17 && hour < 22) {
    this.hiText = '晚上好'
  } else {
    this.hiText = '深夜好'
  }
};

export const validEmail = (email) => {
  let reg = /^[a-z0-9A-Z]+[\-|a-z0-9A-Z._]+@([a-z0-9A-Z]+([\-a-z0-9A-Z]+)\.)+[a-zA-Z]{2,}$/
  return reg.test(email)
}


export const replaceUnderLine = (val, char = '_') => {
  const arr = val.split('')
  const index = arr.indexOf(char)
  arr.splice(index, 2, arr[index + 1].toUpperCase())
  val = arr.join('')
  return val
}


// 替换对象中的下划线
export const filterUnderLine = (obj, char = '_') => {

  const arr = Object.keys(obj)
  arr.forEach(item => {

    if (item.indexOf(char) !== -1) {
      const before = obj[item]
      const key = replaceUnderLine(item)
      obj[key] = before
      delete obj[item]
    }
    if (typeof (obj[item]) === 'object' && obj[item] != null) {
      filterUnderLine(obj[item])
    }
  })
  return obj
}


// 驼峰转下划线
function toUnderLine(str) {
  var temp = str.replace(/[A-Z]/g, function (match) {
    return "_" + match.toLowerCase();
  });
  if (temp.slice(0, 1) === '_') { //如果首字母是大写，执行replace时会多一个_，这里需要去掉
    temp = temp.slice(1);
  }
  return temp;
}

//对象递归的将驼峰转为下划线
export const toUnderLineObj = (obj, char = '_') => {
  // console.log(obj)

  const arr = Object.keys(obj)
  arr.forEach(item => {
    if (/[A-Z]/.test(item)) {

      const before = obj[item]
      const key = toUnderLine(item)
      obj[key] = before

      delete obj[item]

    }
    if (typeof (obj[item]) === 'object' && obj[item] != null) {
      toUnderLineObj(obj[item])
    }
  })
  // console.log(obj)
  return obj
}


// 字符串2020-07-17转换日期格式
export const strToDate = (str) => {
  str = str.replace(/-/g, '/')
  var date = new Date(str)
  return date
}

// 2020-07-17T12:00:00 转日期格式
export const strToDateTime = (str, str2) => {

  let b = str.split("-");
  let c = str2.split(":");
  let date = new Date(b[0], b[1], b[2], c[0], c[1], c[2]);
  return date;
}


export const toAge = (birthday) => {
  let date = new Date()
  if (birthday != null) {
    let startDate = typeof (birthday) == 'string' ? new Date(birthday.replace(/-/g, '/')) : birthday
    let interval = (date - startDate) / (365 * 24 * 60 * 60 * 1000)
    if (interval < 1) {
      return 1
    } else {
      return Math.floor(interval)
    }
  } else {
    return ''
  }
}

export const toworkYear = (startDate) => {
  let date = new Date()
  if (startDate != null) {
    let startDate = typeof (startDate) == 'string' ? new Date(startDate.replace(/-/g, '/')) : startDate
    let interval = (date - startDate) / (365 * 24 * 60 * 60 * 1000)
    if (interval < 1) {
      return '1年以下'
    } else {
      if (Math.floor(interval) === Math.ceil(interval)) {
        return Math.floor(interval)
      } else {
        return Math.ceil(interval) + '年'
      }
    }
  } else {
    return ''
  }
}


export const getNow=()=>{


  let d = new Date();
  return d.getFullYear()+"-" + (d.getMonth()+1) + "-" + d.getDate() + 'T' + d.getHours() + ':'+ d.getMinutes() + ':'+ d.getSeconds();

};









//////////////////
// WEBPACK FOOTER
// ./static/js/util.js
// module id = null
// module chunks = 